// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import RequestSummaryItemResourceViewModel from '../../../../viewModel/resource/RequestSummaryItemResourceViewModel';
import RequestSummaryItemResourceDTO from '../../dto/resource/RequestSummaryItemResourceDTO';

export default abstract class RequestSummaryItemResourceModel extends BaseModel<RequestSummaryItemResourceDTO> {
  /**
  */
  get downloadLink() { return this.dto.downloadLink; }
  set downloadLink(value) { this.dto.downloadLink = value; }
  /**
  */
  get label() { return this.dto.label; }
  set label(value) { this.dto.label = value; }
  /**
  */
  get displayValue() { return this.dto.displayValue; }
  set displayValue(value) { this.dto.displayValue = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.downloadLink = qs.downloadlink;
    this.dto.label = qs.label;
    this.dto.displayValue = qs.displayvalue;
  }
}
